export interface INkrReferralDonatedNkr {
    centerId: number,
    centerAlias: string,
    allDashDonorsTransplanted: number,
    referredDonorsTransplanted: number
}